import React from 'react';
import { SkeletonTheme } from 'react-loading-skeleton';
import { SkeletonWrapper, SkeletonLoad, SkeletonDealerWrapper } from './Skeleton.styles';
import { COLORS } from '../../styles/variables';

export const SkeletonImage: React.FC = () => {
  return (
    // @ts-ignore
    <SkeletonTheme color={COLORS.skeletonColor} highlightColor={COLORS.highlightColor}>
      <SkeletonWrapper>
        <SkeletonLoad className="image" data-testid="skeleton-image" />
      </SkeletonWrapper>
    </SkeletonTheme>
  );
};

export const SkeletonVehicle: React.FC = () => {
  return (
    // @ts-ignore
    <SkeletonTheme color={COLORS.skeletonColor} highlightColor={COLORS.highlightColor}>
      <SkeletonWrapper>
        <SkeletonLoad className="vehicleName" data-testid="skeleton-vehicle-name" />
        <SkeletonLoad className="vehicleTrim" data-testid="skeleton-vehicle-trim" />
      </SkeletonWrapper>
    </SkeletonTheme>
  );
};

export const SkeletonDealerAddress: React.FC = () => {
  return (
    // @ts-ignore
    <SkeletonTheme color={COLORS.skeletonColor} highlightColor={COLORS.highlightColor}>
      <SkeletonDealerWrapper>
        <SkeletonLoad className="dealerAddress" data-testid="skeleton-dealer-address" />
      </SkeletonDealerWrapper>
    </SkeletonTheme>
  );
};

export const SkeletonDealerPhone: React.FC = () => {
  return (
    // @ts-ignore
    <SkeletonTheme color={COLORS.skeletonColor} highlightColor={COLORS.highlightColor}>
      <SkeletonDealerWrapper>
        <SkeletonLoad className="dealerPhone" data-testid="skeleton-dealer-phone" />
      </SkeletonDealerWrapper>
    </SkeletonTheme>
  );
};
